export const IntegrationIcon = ({
  className = 'text-white',
}: {
  className: string;
}) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      width="20"
      height="20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)" stroke="currentColor" strokeLinejoin="round">
        <path d="M9.375 8.932a1.48 1.48 0 012.093 0l1.27-1.27a.641.641 0 000-.906L11.02 5.04a1.48 1.48 0 10-1.704-1.704L7.601 1.62a.641.641 0 00-.906 0l-1.27 1.269a1.48 1.48 0 00-2.19 1.986.158.158 0 01-.008.212l-1.669 1.67a.64.64 0 000 .906l5.136 5.136a.641.641 0 00.907 0l1.663-1.663a.166.166 0 00.01-.223 1.48 1.48 0 01.101-1.98v0z" />
        <path d="M7.863 12.983s-.55-.084-.549.085c0 .169.433.695.553.815l1.71 1.71A1.457 1.457 0 008.4 17.386a1.483 1.483 0 001.88 1.06 1.455 1.455 0 00.997-1.153l1.71 1.71a.632.632 0 00.9.003l1.257-1.255a1.48 1.48 0 01-.435-1.04 1.459 1.459 0 011.39-1.463 1.48 1.48 0 011.004.332.166.166 0 00.22-.01l1.647-1.645a.632.632 0 00.184-.45.641.641 0 00-.188-.45l-5.12-5.12c-.119-.12-.646-.552-.814-.553" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="currentColor" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
